import Page from "../PublicPage";
import { Password } from "@mui/icons-material";
import ResetPasswordForm from "./ResetPasswordForm";

export default function ResetPassword() {
  return (
    <Page
      title={"PUBLIC.title_reset_password"}
      icon={<Password fontSize="inherit" />}
    >
      <ResetPasswordForm />
    </Page>
  );
}
